import { IRateClass } from "../store/interfaces";
import { useAppStore } from "./useAppStore";
import { useEligibilityStore } from "./useEligibilityStore";
import { useHasDependents } from "./useHasDependents";

const useGetClassInfo = () => {
  const { eligibilityStore } = useEligibilityStore();
  const {
    appStore: { planInfo },
  } = useAppStore();
  const {hasDependents, hasSpouse, hasFamily} = useHasDependents();

  const {
    isUnder19,
    pediatricDental: { company, policyNumber, didUserVerify },
  } = eligibilityStore;

  const rateClassObj = (): IRateClass | undefined => {
    if (hasFamily) {
      return planInfo?.rateClasses.Family;
    } else if (hasSpouse) {
      return planInfo?.rateClasses.Double;
    } else if (hasDependents) {
      return planInfo?.rateClasses.Parent;
    } else {
      return planInfo?.rateClasses.Single;
    }
  };

  const getPlanRate = () => {
    const rateClass = rateClassObj();
    const rateClassValue = rateClass?.value;
    const pediatricDentalRate = rateClass?.pediatricDentalRate;

    if (!!isUnder19 && company && policyNumber && !!didUserVerify && !!rateClassValue && !!pediatricDentalRate) {
      return +rateClassValue - +pediatricDentalRate;
    }

    return rateClassValue;
  };

  return { getPlanRate, rateClassObj };
};

export default useGetClassInfo;
